export default "__VITE_ASSET__Qz25g2Vg__"